<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.753,9.5257c-0.064,0-0.129-0.012-0.192-0.0381
      c-0.255-0.1059-0.376-0.399-0.27-0.6529l0.478-1.155c0.106-0.256,0.401-0.375,0.654-0.2711c0.255,0.1061,0.376,0.399,0.27,0.654
      l-0.478,1.1541C12.135,9.4096,11.949,9.5257,11.753,9.5257 M8.479,9.2167l0.478-1.1541c0.106-0.255-0.015-0.5479-0.27-0.654
      C8.434,7.3047,8.14,7.4236,8.034,7.6797l-0.479,1.155C7.45,9.0886,7.571,9.3817,7.826,9.4876
      c0.062,0.0261,0.127,0.0381,0.191,0.0381C8.213,9.5257,8.399,9.4096,8.479,9.2167 M15.951,9.2167l0.478-1.1541
      c0.106-0.255-0.016-0.5479-0.27-0.654c-0.253-0.1039-0.548,0.015-0.654,0.2711l-0.478,1.155c-0.106,0.2539,0.015,0.5471,0.27,0.6529
      c0.063,0.0261,0.128,0.0381,0.192,0.0381C15.684,9.5257,15.871,9.4096,15.951,9.2167"/>
    <rect fill="none" width="24" height="24"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0001,11.9998h-18c-0.552,0-1,1.0001-1,1.0001s0.448,1.0001,1,1.0001h1.0004
      c0.0022,0.001,0.9996,0.4485,0.9996,0.9999v2c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.5514,0.9974-0.9989,0.9996-0.9999h0.0007
      c0.0022,0.001,0.9996,0.4485,0.9996,0.9999v2c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.5514,0.9974-0.9989,0.9996-0.9999h0.0007
      c0.0022,0.001,0.9996,0.4485,0.9996,0.9999v2c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.5514,0.9974-0.9989,0.9996-0.9999h0.0007
      c0.0022,0.001,0.9996,0.4485,0.9996,0.9999v2c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.5514,0.9974-0.9989,0.9996-0.9999h1.0004
      c0.552,0,1-1.0001,1-1.0001S21.5521,11.9998,21.0001,11.9998z"/>
  </g>
</template>

<script>
export default {
  name: 'FreezingDrizzle'
}
</script>